<form [formGroup]="tmprForm" *ngIf="tmprForm" (ngSubmit)="onSubmit()" class="myform">
    <div class="p-5">
      <div class="flex justify-center items-baseline flex-wrap">
        <div class="flex m-2">
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label><i>k</i> value</mat-label>
            <input matInput formControlName="gammaVal" autocomplete="off">
            <mat-error *ngIf="tmprForm.invalid && tmprForm.touched">
              <span class="myerror">1.0 &lt; <i>k</i> &le; 1.67</span>
            </mat-error>
          </mat-form-field>
        </div>
    
        <div class="flex m-2">
          <mat-form-field [hideRequiredMarker]="true">
            <mat-label>Temperature ratio</mat-label>
              <input matInput formControlName="tmprVal" autocomplete="off">
              <mat-error *ngIf="tmprForm.invalid && tmprForm.touched">
                <span class="myerror"> T / T<sub>t</sub> < 1 </span>
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        
        <div class="sbmtArea flex justify-center items-baseline flex-wrap">
          <button mat-raised-button type="submit" [disabled]="tmprForm.invalid">Calculate</button>
        </div>
      </div>
    </form>
        
    <div class="flex justify-center items-baseline flex-wrap" *ngIf="tBool">
      <table>
        <tr>
          <td>
            Mach
          </td>
              <span class="asana2">
                <td> {{ isenMach()}} </td>
              </span>
              
              </tr>
              <tr>
                <td>
                    p / p<sub>0</sub>
                </td>
                <td>
                  <span class="asana2">
                    {{ isenp_pt() | number:'.1-5' }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                    A / A<sub>t</sub>
                </td>
                <!-- <td><aas></aas></td> -->
                  <span class="asana2">
                    <td>{{ isenA_As() | number:'.1-5'}}</td>
                  </span>
              </tr>
              <tr>
                <td>
                    pA / p<sub>0</sub>A<sub>t</sub>
                <td>
                <!-- <td><paptas></paptas></td> -->
                <span class="asana2">
                  {{ isenpA_ptAstar()  | number:'.1-5'  }}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <span>Prandtl-Meyer flow (ν)</span>
                </td>
  
  
                <td>
                  <span class="asana2">
  
                  
                  {{ isenpm() | number:'.1-5' }}
                </span>
                
                </td>
  
              </tr>
              <tr>
                <td>
                    <span>Mach angle (μ)</span>      
                </td>
                <td>
                  <span class="asana2">
                    {{ isenmach_angle() | number:'.1-5' }}
                  </span>
                
                </td>
              </tr>
              <tr>
                <td>
                    <span matTooltip="Optimal thrust coefficient" matTooltipPosition="left">
                        <span>C<sub>Fopt</sub></span>
                    </span>
                </td>
                <td>
                  <span class="asana2">
                    {{isen_cfopt() | number:'.1-5' }}
                  </span>
                  </td>
              </tr>
        
              <tr>
                <td>
                    <span>ρ/ρ<sub>0</sub></span>
                </td>
                <td>
                  <span class="asana2">     
                      {{ isen_rhot() | number:'.1-5' }}
                </span>
                </td>
        
              </tr>
              </table>
          </div>
        